import { useState } from "react";
import { Level, Modal } from "react-bulma-components";
import styled from "styled-components";
import About, { Credits, News } from "./Modals";
import { FullScreenModalContent } from "./Utilities";

const StyledLevel = styled(Level)`
  background-color: ${(props) => props.theme.background};
`;
function CareHeader({ headerConfig, ...props }) {
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showCreditsModal, setShowCreditsModal] = useState(false);
  const [showNewsModal, setShowNewsModal] = useState(false);

  return (
    <StyledLevel m="0" breakpoint="mobile">
      <Level.Side align="left">
        <Level.Item
          renderAs="a"
          onClick={() => {
            setShowAboutModal(true);
          }}
        >
          About
        </Level.Item>
        <Level.Item>
          <a
            href={headerConfig.currentAvailabilityRef}
            target="_blank"
            rel="noreferrer noopener"
          >
            Current Availability
          </a>
        </Level.Item>
        <Level.Item
          renderAs="a"
          onClick={() => {
            setShowNewsModal(true);
          }}
          style={{color: "red"}}
        >
          Tickets to watch Care
        </Level.Item>
        <Level.Item>
          <a
            href="https://www.youtube.com/watch?v=tJNxJAxiH4k"
            target="_blank"
            rel="noreferrer noopener"
          >
            References
          </a>
        </Level.Item>
        <Level.Item
          renderAs="a"
          onClick={() => {
            setShowCreditsModal(true);
          }}
        >
          Credits
        </Level.Item>
      </Level.Side>
      <Level.Side align="right">
        <Level.Item>
          <a
            href={headerConfig.referralsRef}
            target="_blank"
            rel="noreferrer noopener"
          >
            Referrals
          </a>
        </Level.Item>
      </Level.Side>
      <Modal
        show={showAboutModal}
        onClose={() => {
          return setShowAboutModal(false);
        }}
      >
        <FullScreenModalContent mt="6">
          <About></About>
        </FullScreenModalContent>
      </Modal>
      <Modal show={showCreditsModal} onClose={() => setShowCreditsModal(false)}>
        <FullScreenModalContent mt="6">
          <Credits></Credits>
        </FullScreenModalContent>
      </Modal>
      <Modal show={showNewsModal} onClose={() => setShowNewsModal(false)}>
        <FullScreenModalContent mt="6">
          <News></News>
        </FullScreenModalContent>
      </Modal>
    </StyledLevel>
  );
}

export default CareHeader;
